export const AUTH_CLIENT_TYPES = [
  "web",
  "app",
  "miniprogram",
  "wechat_mp",
  "douyin_mp",
  "baidu_mp",
] as const;

export type AuthClientType = (typeof AUTH_CLIENT_TYPES)[number];

export function isAuthClientType(value: string): value is AuthClientType {
  return (AUTH_CLIENT_TYPES as readonly string[]).includes(value);
}

export function isNativeAuthClient(clientType: AuthClientType) {
  return clientType !== "web";
}

export function resolveAuthClientType(
  value: unknown,
  request?: { headers: { get(name: string): string | null } },
): AuthClientType {
  if (typeof value === "string" && isAuthClientType(value)) {
    return value;
  }

  const header = request?.headers.get("x-auth-client");

  if (header && isAuthClientType(header)) {
    return header;
  }

  return "web";
}

export function normalizeAuthClientType(value: string): AuthClientType {
  return isAuthClientType(value) ? value : "web";
}
